import { render, staticRenderFns } from "./BulkRejectionDialog.vue?vue&type=template&id=089fc5f6"
import script from "./BulkRejectionDialog.vue?vue&type=script&lang=js"
export * from "./BulkRejectionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports